import { useSearchParams } from '@remix-run/react';
import { useEffect } from 'react';

const useRemoveParam = (param: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = searchParams.get(param);

  useEffect(() => {
    if (searchParam) {
      searchParams.delete(param);
      setSearchParams(searchParams, { replace: true });
    }
  }, [param]);
};

export default useRemoveParam;
